<template>
    <div>
        <div class="title__rank">
            <span v-html="t.title_lifestyle"></span>
            <span class="helper__tooltip purple icon__title">
                <span class="helper__tooltip--text" v-html="t.tooltip_lifestyle"></span>
            </span>
        </div>
        <div class="mansion__bonus card-v4 d-f">
            <div class="graphics">
                <section>
                    <div class="card__grey">
                        <div class="detail">
                            <h2 v-html="t.label_bonus_earned"></h2>
                            <h2>{{ onlyValueFirst }}</h2>
                        </div>
                    </div>
                    <div>
                        <h4 v-html="t.text_lifestyle_bonus"></h4>
                        <h4 v-html="t.text_lifestyle_bonus_bottom"></h4>
                    </div>
                </section>
                <section>
                    <div class="loading__out">
                        <div class="loading__bar">
                            <div class="bar" :style="{ width: firstGraphic + '%' }"></div>
                        </div>
                        <span>{{totalClients}}</span>
                    </div>
                    <h3 v-html="firstGraphicStatic + ' ' + t.label_payment_active_members"></h3>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "life-style",
    components: {},
    data() {
        return {
            t: this.$parent.view.translation.life_style,
            onlyValueFirst: this.$parent.view.dashboard_values_v3.life_style.value,
            totalClients: this.$parent.view.dashboard_values_v3.life_style.total_clients,
            firstGraphic: this.$parent.view.dashboard_values_v3.life_style.graphic_value,
            firstGraphicStatic: this.$parent.view.dashboard_values_v3.life_style.graphic_value,
        };
    },
    mounted() {
        if (this.firstGraphic > 200) this.firstGraphic = 100;
        else this.firstGraphic = (this.firstGraphic * 100) / 200;
    }
};
</script>
<style scoped lang="scss">
.icon__title {
    margin-right: 1rem;
}

.mansion__bonus {
    &.d-f {
        display: flex;
        align-items: center;
    }
    .graphics {
        display: grid;
        grid-template-columns: 2fr 1fr;
        align-items: center;
        width: 95%;
        margin: 0 auto;
        section:first-child {
            display: flex;
            align-items: center;
            .card__grey {
                flex: 0 0 190px;
                background: rgba(237, 240, 245, 0.5);
                border: 1px solid #dadada;
                padding: 0.4rem 0.4rem;
                margin-right: 0.5rem;
                border-radius: 7px;
                .detail {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    h2 {
                        font-size: 1.4rem;
                        &:first-child {
                            margin-top: 0.4rem;
                        }
                        &:last-child {
                            color: #0cad25;
                            font-weight: bold;
                        }
                    }
                }
            }
            h4 {
                color: #707070;
                font-size: .86rem;
                padding: 0 20px;
                &:first-child {
                    line-height: 20px;
                    position: relative;
                    margin-bottom: 20px;
                    font-size: 1rem;
                    &::after {
                        content: '';
                        position: absolute;
                        width: calc(100% - 40px);
                        height: 1px;
                        bottom: -10px;
                        left: 20px;
                        background: rgba(0, 0, 0, 0.1);
                    }
                }
            }

        }
        .loading__out {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            .loading__bar {
                height: 12px;
                border-radius: 15px;
                margin: 0.4rem 0;
                border: 1px solid #c6c6c6;
                width: 80%;
                .bar {
                    border-radius: 15px;
                    height: 10px;
                    background: #0294ff;
                    transition: 0.1s all ease;
                }
            }
            span {
                color: #0294ff;
                font-weight: bold;
            }
        }
        h3 {
            text-align: center;
            color: #707070;
        }
    }
}
@media (max-width: 970px) {
    .mansion__bonus .graphics {
        grid-template-columns: auto;
        section:first-child {
            flex-direction: column;
            margin-bottom: 2rem;
            text-align: center;
            .card__grey {
                flex: unset;
                width: 100%;
            }
        }
    }
}
.helper__tooltip:after {
    top: 0;
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/lifeStyleBonus.vue